<template>
	<div class="CustomBlockWidth " >
		<div class="row no-gutters justify-content-center align-items-center"> 
			<div class=" middleBox">
				<div class="card border-0">
				  <div class="card-body text-center ">
					<img src="../../../../static/fxView/images/lost.svg" alt="no account found" class="mb-4" width="200">  
					<span >																							
						<span v-if="parseInt(get_user.step) < 3 ">
							<p class="text-muted mb-3" v-if="demo_live_both == 'w/l'"> {{$t('tradAcc_application1')}} </p>
							<p class="text-muted mb-3" v-else> {{$t('tradAcc_application')}} <span v-if="demo_live_both == 'b'">{{$t('tradAcc_trading')}}</span><span v-else>{{$t('tradAcc_live')}}</span> {{$t('tradAcc_accountAccess')}}</p>
							<router-link :to="stepPageOpenFunc(get_user.step)" class="prism_btn btn_sm lift">{{$t('tradAcc_resumeApplication')}}</router-link>
						</span>
						<span v-else-if="parseInt(get_user.step) >= 3 && parseInt(get_user.verified_status) == 0">
							<p class="text-muted mb-3" >{{$t('tradAcc_checkappStatus')}}</p> 
							<!-- {{ get_user.step }} -->
							<!-- <button class="prism_btn btn_sm lift" v-on:click.prevent="stepPageOpenFunc(get_user.step)">
								{{$t('tradAcc_resumeApplication')}}
							</button> -->
							<div v-if="parseInt(get_user.step) == 5">
								<a href="#" class="prism_btn btn_sm lift" @click.prevent="redirect()">{{$t('tradAcc_ticket')}}</a>
							</div>
							<div v-else>
								<router-link :to="stepPageOpenFunc(get_user.step)" class="prism_btn btn_sm lift">{{$t('tradAcc_resumeApplication')}}</router-link>
							</div>
						</span>
						<span v-else-if="parseInt(get_user.step) >= 3 && parseInt(get_user.verified_status) >=1 && parseInt(totalRecords) == 0 && demo_live_both == ''">
							<p class="text-muted mb-3" >{{$t('tradAcc_createliveAcc')}}</p> 
							<router-link to="/create-live-account" class="prism_btn btn_sm lift">{{$t('It_liveAcc')}}</router-link>
						</span>
						<span v-else-if="parseInt(get_user.step) >= 3 && parseInt(get_user.verified_status) >= 1 && parseInt(totalRecords) == 0 && demo_live_both == 'b'">
							<p class="text-muted mb-3" >{{$t('tradAcc_liveDemoAcc')}}</p> 
							<router-link to="/create-live-account" class="prism_btn btn_sm lift">{{$t('It_liveAcc')}}</router-link>
							<router-link to="/create-demo-account" class="prism_btn btn_sm lift">{{$t('tradAcc_demoAcc')}}</router-link>
						</span>
						<span v-else-if="parseInt(get_user.step) >= 3 && parseInt(get_user.verified_status) >= 1 && parseInt(totalRecords) == 0 && demo_live_both == 'dw'">
							<p class="text-muted mb-3" >{{$t('tradAcc_createWallet')}}</p> 
							<div @click="handleWalletRoute" class="prism_btn btn_sm lift">{{$t('tradAcc_wallet')}}</div>
						</span>
					</span>
				  </div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'Deposit',
        mixins: [fxViewMixins],
        data() {
            return {
            	
            }
        },
		props:['demo_live_both', 'totalRecords'],
		methods:{
			handleWalletRoute() {
				window.location.reload();
			}
		},
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/no_trading_account.vue